// A signed-in user belongs to an organization when the session names an active
// one, or (for sessions issued before that was set) when they are a member of any.
export async function userHasOrganization(
  activeOrganizationId: string | null | undefined,
  listOrganizations: () => Promise<unknown[]>,
): Promise<boolean> {
  if (activeOrganizationId) return true;
  return (await listOrganizations()).length > 0;
}
